import styles from "./MicrositeCTA.module.scss";
import { UnderlinedButton } from "@JohnLewisPartnership/jl-design-system/dist/components/button/Button";
import { OpenInNewOutlined } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/OpenInNewOutlined";
import classNames from "classnames/bind";
import { useTradeInContext } from "../../TradeInContext";

const cx = classNames.bind(styles);

type Props = {
  isFullWidthMode: boolean;
  hasMultipleTradeInRoutes: boolean;
};

export const MicrositeCTAUI = ({
  isFullWidthMode,
  hasMultipleTradeInRoutes,
}: Props) => {
  const { micrositeUrl, micrositeOnClick, flags } = useTradeInContext();
  const showNewTradeInUI = flags.showNewTradeInUI.value === true;

  return (
    <div
      className={cx(styles.cta, {
        "cta-new": showNewTradeInUI,
        "cta--standalone": !showNewTradeInUI && !hasMultipleTradeInRoutes,
        fullWidthMode: isFullWidthMode,
      })}
      data-testid="trade-in-microsite-cta"
    >
      {showNewTradeInUI ? (
        <h2 className={styles.cta__title}>
          Sell your device to get a little something back for a future purchase
        </h2>
      ) : (
        <>
          <h2 className={styles.cta__title}>
            {hasMultipleTradeInRoutes && "Or "}sell your device
          </h2>
          <p className={styles.cta__description}>
            To get a little something back for a future purchase
          </p>
        </>
      )}

      <div className={styles.cta__iconLink}>
        <UnderlinedButton
          tag="a"
          href={micrositeUrl}
          target="_blank"
          rel="noopener noreferrer"
          onClick={micrositeOnClick}
          labelText="Find out more"
        />
        <OpenInNewOutlined size="medium" />
      </div>
    </div>
  );
};
